// ── Gemeente database ──────────────────────────────────────────────────────
// Uitbreidbaar: voeg gemeenten toe met bbox voor Overpass API + wijkdata.
// welvaartsindex: Statbel-indicator van de gemeente (Vlaams gemiddelde 106,9,
// zie WELVAARTSINDEX_VLAANDEREN). Wordt NIET MEER gebruikt om het EV-aandeel
// te corrigeren; zie evAandeelGemeente. Het veld blijft staan omdat het bij het
// onboarden wordt ingevuld en opgeslagen. privePctBerekend: aandeel huishoudens
// met privé laadmogelijkheid (0 tot 1); voor Leuven een echte, straatniveau
// meting, voor andere gemeenten voorlopig een schatting (zie Leeswijzer §9)
// totdat de Stadsmonitor- of Fluvius-koppeling per gemeente is gebouwd.
// evAandeelOverride: optioneel, alleen invullen als er een eigen, lokale
// EV-prognose is die de wagens van gezinnen meet en niet de inschrijvingen;
// anders leeg laten zodat de Vlaamse reeks geldt.
export const GEMEENTEN = {
  leuven: {
    id: 'leuven',
    naam: 'Leuven',
    provincie: 'Vlaams-Brabant',
    inwoners: 104906,
    voertuigen: 48200,
    oppervlakteKm2: 56.63, // extern geverifieerd (Stad Leuven, officiële opgave)
    postcodes: ['3000','3001','3010','3012','3018'], // extern geverifieerd (bpost)
    welvaartsindex: 115, // schatting; wordt niet meer gebruikt in de berekening
    privePctBerekend: 0.636, // extern geverifieerd: eigen straatniveau-dataset (1.077 straten)
    // evAandeelOverride bewust leeg: de waarden 0,376 en 0,595 zijn op 19 augustus 2026
    // verwijderd. Herkomst niet te achterhalen en beide volgen de inschrijvingsreeks van
    // Leuven, die voor negen tiende uit de vloot van KBC Autolease bestaat.
    center: [50.8798, 4.7005],
    zoom: 13,
    bbox: [50.82, 4.65, 50.94, 4.77], // [south, west, north, east]
    kleur: '#2B5F6E',
    wijken: [
      { id:'LV01', naam:'Leuven Centrum',       inwoners:18400, voertuigen:7200,  wijktype:['binnenstad'],       oppervlakteKm2:10.17, lat:50.8793, lng:4.7009 },
      { id:'LV02', naam:'Kessel-Lo',            inwoners:22100, voertuigen:9800,  wijktype:['woonwijk'],         oppervlakteKm2:12.21, lat:50.8900, lng:4.7280 },
      { id:'LV03', naam:'Heverlee',             inwoners:19600, voertuigen:9100,  wijktype:['woonwijk'],         oppervlakteKm2:10.83, lat:50.8560, lng:4.7050 },
      { id:'LV04', naam:'Wilsele',              inwoners:12300, voertuigen:5600,  wijktype:['woonwijk'],         oppervlakteKm2:6.80,  lat:50.9100, lng:4.7050 },
      { id:'LV05', naam:'Wijgmaal',             inwoners:5200,  voertuigen:2400,  wijktype:['woonwijk'],         oppervlakteKm2:2.87,  lat:50.9280, lng:4.7120 },
      { id:'LV06', naam:'Haasrode / Korbeek-Lo',inwoners:8900,  voertuigen:4200,  wijktype:['bedrijventerrein'], oppervlakteKm2:4.92,  lat:50.8420, lng:4.7400 },
      { id:'LV07', naam:'Binnenstad Oost',      inwoners:9800,  voertuigen:3200,  wijktype:['binnenstad'],       oppervlakteKm2:5.41,  lat:50.8780, lng:4.7160 },
      { id:'LV08', naam:'Arenberg / Wetensch.', inwoners:6200,  voertuigen:4800,  wijktype:['woonwijk'],         oppervlakteKm2:3.43,  lat:50.8640, lng:4.6880 },
    ],
  },
  olen: {
    id: 'olen',
    naam: 'Olen',
    provincie: 'Antwerpen',
    inwoners: 14000,
    voertuigen: 8200,
    oppervlakteKm2: 23.10, // extern geverifieerd (Wikipedia/officiële opgave)
    postcodes: ['2250'], // extern geverifieerd (Wikipedia)
    welvaartsindex: 107, // extern geverifieerd (gemeente Olen zelf)
    privePctBerekend: 0.70, // schatting, nog te verifiëren (Stadsmonitor)
    center: [51.1400, 4.8600],
    zoom: 13,
    bbox: [51.10, 4.82, 51.18, 4.91],
    kleur: '#3A6B4A',
    wijken: [
      { id:'OL01', naam:'Olen Centrum',    inwoners:5200,  voertuigen:3100, wijktype:['binnenstad'],       oppervlakteKm2:8.58, lat:51.1380, lng:4.8580 },
      { id:'OL02', naam:'Olen Noord',      inwoners:3800,  voertuigen:2300, wijktype:['woonwijk'],         oppervlakteKm2:6.27, lat:51.1520, lng:4.8550 },
      { id:'OL03', naam:'Industriezone',   inwoners:800,   voertuigen:1200, wijktype:['bedrijventerrein'], oppervlakteKm2:1.32, lat:51.1350, lng:4.8750 },
      { id:'OL04', naam:'Olen Oost',       inwoners:4200,  voertuigen:2600, wijktype:['woonwijk'],         oppervlakteKm2:6.93, lat:51.1380, lng:4.8820 },
    ],
  },
  gent: {
    id: 'gent',
    naam: 'Gent',
    provincie: 'Oost-Vlaanderen',
    inwoners: 268000,
    voertuigen: 112000,
    oppervlakteKm2: 156.18, // extern geverifieerd (Wikipedia/officiële opgave)
    postcodes: ['9000','9030','9031','9032','9040','9050','9051','9052'], // beste inschatting, mogelijk niet volledig
    welvaartsindex: 98, // schatting, nog te verifiëren bij Statbel
    privePctBerekend: 0.60, // schatting, nog te verifiëren (Stadsmonitor)
    center: [51.0543, 3.7174],
    zoom: 12,
    bbox: [50.99, 3.64, 51.12, 3.80],
    kleur: '#9EC5CB',
    wijken: [
      { id:'GN01', naam:'Gent Centrum',      inwoners:28000, voertuigen:9800,  wijktype:['binnenstad'],       oppervlakteKm2:39.75, lat:51.0543, lng:3.7174 },
      { id:'GN02', naam:'Ledeberg',          inwoners:18000, voertuigen:7200,  wijktype:['woonwijk'],         oppervlakteKm2:25.56, lat:51.0380, lng:3.7350 },
      { id:'GN03', naam:'Wondelgem',         inwoners:22000, voertuigen:9400,  wijktype:['woonwijk'],         oppervlakteKm2:31.24, lat:51.0850, lng:3.7100 },
      { id:'GN04', naam:'Mariakerke',        inwoners:19000, voertuigen:8200,  wijktype:['woonwijk'],         oppervlakteKm2:26.98, lat:51.0620, lng:3.6900 },
      { id:'GN05', naam:'Gentse Kanaalzone', inwoners:8000,  voertuigen:5800,  wijktype:['bedrijventerrein'], oppervlakteKm2:11.36, lat:51.0900, lng:3.7500 },
      { id:'GN06', naam:'Drongen',           inwoners:15000, voertuigen:6800,  wijktype:['woonwijk'],         oppervlakteKm2:21.30, lat:51.0350, lng:3.6650 },
    ],
  },
};

// ── Rekenmodel v2 ───────────────────────────────────────────────────────
// Herbouwd volgens "18072026 Strategisch Laadplan Simulator V14.xlsx" en
// "Leeswijzer Strategisch Laadplan Modellering.docx". Elke constante hieronder
// heeft in dat Excel-bestand (tabblad Parameters) een bronvermelding en een
// status (extern geverifieerd / eigen werkaanname / nog te verifiëren).
// Dit bestand bevat alleen de rekenkern (Stap 1 t/m 4 + bruto-uitkomst);
// de aftrek van bestaande infrastructuur en "gepland" gebeurt, net als
// voorheen, op app-niveau (AppWithOnboarding.js), niet hier.

// Stap 1 — energiebehoefte per EV
//
// Op 20 augustus 2026 kortstondig verhoogd naar 30.000 km en 0,20 kWh, om het
// gat te dichten tussen de berekende publieke vraag in Leuven en wat er
// werkelijk door de laadpunten gaat. Diezelfde dag teruggedraaid: dat gat komt
// niet doordat Leuvenaars meer rijden, maar doordat er bezoekers en forenzen
// laden die niet in Leuven wonen. Het hoort dus in de bezoekersfactor en niet
// in het verbruik per auto, anders krijgt ook een dorp zonder bezoekers een
// 41 procent hogere vraag.
export const JAARKM = 25000;            // eigen werkaanname (MOW TCO-tool: 30.000 bedrijf / 15.000 privé)
export const VERBRUIK_PER_KM = 0.17;    // marktconsensus (Energids/Plugnet/Vattenfall e.a.)
export const STADSFACTOR = 0.95;        // eigen werkaanname

// EV-aandeel Vlaanderen, basiswaarde. Afgeleid uit het Fluvius Investeringsplan
// 2026-2035, dat 8,5 / 22,2 / 40,7 procent noemt voor ALLE ingeschreven wagens.
// Die reeks telt de vloot van leasemaatschappijen mee, en die wagens staan 's
// nachts niet in de gemeente waar ze zijn ingeschreven. Voor een laadplan telt
// alleen de wagen die bij een gezin hoort, dus is de reeks omgerekend met een
// factor 0,77 (2025), 0,79 (2030) en 0,83 (2035). Die factor volgt uit het
// aandeel bedrijfswagens: 28,7 procent van alle ingeschreven wagens in
// Vlaanderen tegen 20,7 procent van de wagens bij een gezin. Controle op 2025:
// 6,5 procent tegenover 6,1 procent gemeten per 1 augustus 2025; het verschil
// is vijf maanden groei, want de Fluvius-reeks geldt per eindejaar.
// Zie stap2_elektrisch_aandeel.docx, 18 augustus 2026.
export const EV_AANDEEL_VLAANDEREN = { 2025: 0.065, 2030: 0.175, 2035: 0.340 };
export const WELVAARTSINDEX_VLAANDEREN = 106.9; // Statbel, Vlaams gemiddelde

// Stap 3 — doelgroepenmix per wijktype
// Verdeling van de publieke laadvraag over bewoners, bezoekers en logistiek,
// per soort wijk. Herzien op 20 augustus 2026: logistiek is uit de woonwijk en
// uit de binnenstad gehaald. Vrachtverkeer laadt op een bedrijventerrein, niet
// in een woonstraat, en de fractie logistiek die er stond zorgde ervoor dat
// elke woonwijk een fractie ultrasnel kreeg. Wat vrijkwam is naar bewoners
// gegaan. Daarvoor stond hier binnenstad 40/55/5 en woonwijk 77/20/3.
export const WIJKTYPE_MIX = {
  binnenstad:       { bew: 0.45, bez: 0.55, log: 0.00 },
  woonwijk:         { bew: 0.80, bez: 0.20, log: 0.00 },
  bedrijventerrein: { bew: 0.00, bez: 0.35, log: 0.65 },
};
// Verdeling over gewoon, snel en ultrasnel laden per doelgroep, op basis van
// hoe lang een voertuig stilstaat. Herzien op 20 augustus 2026: bezoekers
// laden niet meer ultrasnel; die 5 procent is naar snelladen gegaan. Daarmee
// ontstaat ultrasnel alleen nog via logistiek, en logistiek komt alleen voor
// op een bedrijventerrein. Een woonwijk en een binnenstad krijgen dus geen
// ultrasnellader meer toebedeeld. Daarvoor stond hier bez 65/30/5.
export const DOELGROEP_LAADTYPE = {
  bew: { ac: 0.95, dc: 0.05, hpc: 0.00 },
  bez: { ac: 0.65, dc: 0.35, hpc: 0.00 },
  log: { ac: 0.15, dc: 0.65, hpc: 0.20 },
};

// ── Bezettingsgraad van de publieke laadpunten, per gemeente ────────────
// Het deel van de tijd dat er een auto aan een laadpunt hangt, over het
// vierde kwartaal van 2025. Bron: Vlaams Parlement, schriftelijke vraag 1093
// van Brecht Warnez aan de minister van Mobiliteit, 17 maart 2026, bijlage 1.
// De minister meldt daarbij dat deze cijfers zo goed als alle publieke
// laadpalen op het openbaar domein in Vlaanderen dekken, namelijk die van
// Allego, TotalEnergies en Engie samen.
//
// LET OP bij het gebruik:
// - Het gaat om laadpunten op het OPENBAAR DOMEIN. Een laadpunt op een
//   winkelparking of bedrijfsterrein haalt deze bezetting niet.
// - Een gemeente met een eigen concessie buiten de Vlaamse aanbesteding om
//   zit er niet in.
// - De bezettingsgraad meet AANGEKOPPELDE tijd, niet laadtijd. Waar een
//   rotatietarief geldt (Leuven sinds 1 juni 2024, Kortenberg sinds
//   1 januari 2026, Kontich en Boechout sinds 2025) kan de bezetting dalen
//   zonder dat er minder stroom doorgaat.
// - Zeventien Vlaamse gemeenten ontbreken in de bron, deels door fusies:
//   Beveren, Bilzen, De Pinte, Galmaarden, Gooik, Ham, Herne, Hoeselt,
//   Kruibeke, Melle, Merelbeke, Meulebeke, Moerbeke, Nazareth, Tessenderlo,
//   Tongeren en Wachtebeke. Daarvoor geldt BEZETTING_NAAR_INWONERTAL.
//
// Waarden in procent, zoals gepubliceerd. Zie ook het overzicht
// 190826_laadpuntgebruik_per_gemeente.xlsx.
export const BEZETTINGSGRAAD_Q4_2025 = {
  'Aalst':33, 'Aalter':19, 'Aarschot':33, 'Aartselaar':29, 'Affligem':32, 'Alken':18,
  'Alveringem':15, 'Antwerpen':44, 'Anzegem':23, 'Ardooie':23, 'Arendonk':19, 'As':16,
  'Asse':34, 'Assenede':26, 'Avelgem':22, 'Baarle-Hertog':13, 'Balen':19, 'Beernem':34,
  'Beerse':26, 'Beersel':27, 'Begijnendijk':32, 'Bekkevoort':42, 'Beringen':21, 'Berlaar':26,
  'Berlare':24, 'Bertem':40, 'Bever':23, 'Bierbeek':30, 'Bilzen-Hoeselt':26, 'Blankenberge':41,
  'Bocholt':15, 'Boechout':30, 'Bonheiden':33, 'Boom':25, 'Boortmeerbeek':38, 'Borgloon':22,
  'Bornem':30, 'Borsbeek':24, 'Boutersem':33, 'Brakel':15, 'Brasschaat':33, 'Brecht':18,
  'Bredene':23, 'Bree':28, 'Brugge':27, 'Buggenhout':34, 'Damme':23, 'De Haan':18,
  'De Panne':22, 'Deerlijk':27, 'Deinze':31, 'Denderleeuw':22, 'Dendermonde':30,
  'Dentergem':29, 'Dessel':16, 'Destelbergen':28, 'Diepenbeek':30, 'Diest':31, 'Diksmuide':26,
  'Dilbeek':34, 'Dilsen-Stokkem':13, 'Drogenbos':31, 'Duffel':32, 'Edegem':42, 'Eeklo':18,
  'Erpe-Mere':27, 'Essen':18, 'Evergem':27, 'Gavere':28, 'Geel':28, 'Geetbets':24, 'Genk':28,
  'Gent':44, 'Geraardsbergen':27, 'Gingelom':19, 'Gistel':19, 'Glabbeek':33, 'Grimbergen':32,
  'Grobbendonk':44, 'Haacht':35, 'Haaltert':31, 'Halen':32, 'Halle':31, 'Hamme':29,
  'Hamont-Achel':13, 'Harelbeke':39, 'Hasselt':42, 'Hechtel-Eksel':47, 'Heers':16,
  'Heist-op-den-Berg':31, 'Hemiksem':31, 'Herent':40, 'Herentals':32, 'Herenthout':24,
  'Herk-de-Stad':29, 'Herselt':17, 'Herstappe':8, 'Herzele':32, 'Heusden-Zolder':21,
  'Heuvelland':16, 'Hoegaarden':34, 'Hoeilaart':32, 'Holsbeek':36, 'Hooglede':14,
  'Hoogstraten':31, 'Horebeke':16, 'Houthalen-Helchteren':28, 'Houthulst':9, 'Hove':36,
  'Huldenberg':34, 'Hulshout':45, 'Ichtegem':22, 'Ieper':26, 'Ingelmunster':14, 'Izegem':21,
  'Jabbeke':25, 'Kalmthout':20, 'Kampenhout':30, 'Kapelle-op-den-Bos':43, 'Kapellen':23,
  'Kaprijke':23, 'Kasterlee':19, 'Keerbergen':37, 'Kessel-Lo':45, 'Kinrooi':9,
  'Kluisbergen':28, 'Knokke-Heist':32, 'Koekelare':18, 'Koksijde':31, 'Kontich':35,
  'Kortemark':15, 'Kortenaken':21, 'Kortenberg':33, 'Kortessem':23, 'Kortrijk':35,
  'Kraainem':33, 'Kruisem':32, 'Kuurne':24, 'Laakdal':22, 'Laarne':21, 'Lanaken':26,
  'Landen':31, 'Langemark-Poelkapelle':29, 'Lebbeke':27, 'Lede':31, 'Ledegem':29,
  'Lendelede':17, 'Lennik':21, 'Leopoldsburg':21, 'Leuven':46, 'Lichtervelde':27,
  'Liedekerke':22, 'Lier':42, 'Lierde':21, 'Lievegem':26, 'Lille':29, 'Linkebeek':35,
  'Lint':29, 'Linter':26, 'Lo-Reninge':11, 'Lochristi':21, 'Lokeren':30, 'Lommel':22,
  'Londerzeel':34, 'Lubbeek':28, 'Lummen':23, 'Maarkedal':22, 'Maaseik':30, 'Maasmechelen':16,
  'Machelen':27, 'Maldegem':15, 'Malle':19, 'Mechelen':46, 'Meerhout':22, 'Meise':34,
  'Menen':26, 'Merchtem':35, 'Merelbeke-Melle':31, 'Merksplas':25, 'Mesen':25,
  'Middelkerke':27, 'Mol':26, 'Moorslede':21, 'Mortsel':41, 'Nazareth-De Pinte':29, 'Niel':37,
  'Nieuwerkerken':19, 'Nieuwpoort':29, 'Nijlen':30, 'Ninove':30, 'Olen':35, 'Oostende':30,
  'Oosterzele':36, 'Oostkamp':33, 'Oostrozebeke':22, 'Opwijk':31, 'Oud-Heverlee':40,
  'Oud-Turnhout':23, 'Oudenaarde':31, 'Oudenburg':28, 'Oudsbergen':18, 'Overijse':30,
  'Pajottegem':20, 'Peer':24, 'Pelt':26, 'Pepingen':24, 'Pittem':21, 'Poperinge':19,
  'Putte':26, 'Puurs-Sint-Amands':35, 'Ranst':26, 'Ravels':25, 'Retie':35, 'Riemst':22,
  'Rijkevorsel':21, 'Roeselare':25, 'Ronse':19, 'Roosdaal':29, 'Rotselaar':36, 'Ruiselede':22,
  'Rumst':34, 'Schelle':34, 'Scherpenheuvel-Zichem':30, 'Schilde':24, 'Schoten':33,
  'Sint-Genesius-Rode':34, 'Sint-Gillis-Waas':38, 'Sint-Katelijne-Waver':23,
  'Sint-Laureins':21, 'Sint-Lievens-Houtem':28, 'Sint-Martens-Latem':28, 'Sint-Niklaas':36,
  'Sint-Pieters-Leeuw':26, 'Sint-Truiden':32, 'Spiere-Helkijn':13, 'Stabroek':15, 'Staden':16,
  'Steenokkerzeel':26, 'Stekene':23, 'Temse':32, 'Ternat':32, 'Tervuren':46,
  'Tessenderlo-Ham':17, 'Tielt':19, 'Tielt-Winge':34, 'Tienen':52, 'Tongeren-Borgloon':28,
  'Torhout':20, 'Tremelo':41, 'Turnhout':31, 'Veurne':20, 'Vilvoorde':40, 'Vleteren':15,
  'Voeren':11, 'Vorselaar':27, 'Vosselaar':34, 'Waasmunster':31, 'Waregem':31, 'Wellen':27,
  'Wemmel':40, 'Wervik':21, 'Westerlo':19, 'Wetteren':33, 'Wevelgem':26, 'Wezembeek-Oppem':23,
  'Wichelen':29, 'Wielsbeke':20, 'Wijnegem':35, 'Willebroek':43, 'Wingene':18, 'Wommelgem':25,
  'Wortegem-Petegem':28, 'Wuustwezel':20, 'Zandhoven':30, 'Zaventem':31, 'Zedelgem':22,
  'Zele':29, 'Zelzate':22, 'Zemst':38, 'Zoersel':25, 'Zonhoven':18, 'Zonnebeke':16,
  'Zottegem':28, 'Zoutleeuw':19, 'Zuienkerke':10, 'Zulte':26, 'Zutendaal':24, 'Zwalm':20,
  'Zwevegem':28, 'Zwijndrecht':32,
};

// Terugval als een gemeente niet in BEZETTINGSGRAAD_Q4_2025 staat: de mediaan
// van de gemeenten met evenveel inwoners, gemeten op dezelfde bron. Alleen
// bedoeld voor de zeventien ontbrekende gemeenten en voor een gemeente buiten
// Vlaanderen; voor alle andere gemeenten geldt de gemeten waarde hierboven.
export const BEZETTING_NAAR_INWONERTAL = [
  { totInwoners:  10000, bezetting: 24, gemeenten:  64 },
  { totInwoners:  20000, bezetting: 26, gemeenten: 121 },
  { totInwoners:  35000, bezetting: 28, gemeenten:  62 },
  { totInwoners:  75000, bezetting: 31, gemeenten:  25 },
  { totInwoners: Infinity, bezetting: 39, gemeenten: 10 },
];

/**
 * Bezettingsgraad van een gemeente in procent, over het vierde kwartaal 2025.
 * Geeft de gemeten waarde als die er is, anders de mediaan van gemeenten met
 * evenveel inwoners. Het tweede element van het antwoord zegt welke van de
 * twee het is, zodat het scherm en het rapport dat kunnen vermelden.
 *
 * @param {string} naam - naam van de gemeente, zoals in BEZETTINGSGRAAD_Q4_2025
 * @param {number} inwoners - alleen nodig voor de terugval
 * @returns {{bezetting:number, gemeten:boolean}}
 */
export function bezettingsgraadGemeente(naam, inwoners) {
  const gemeten = BEZETTINGSGRAAD_Q4_2025[naam];
  if (gemeten != null) return { bezetting: gemeten, gemeten: true };
  const klasse = BEZETTING_NAAR_INWONERTAL.find(k => (inwoners ?? 0) < k.totInwoners)
    ?? BEZETTING_NAAR_INWONERTAL[BEZETTING_NAAR_INWONERTAL.length - 1];
  return { bezetting: klasse.bezetting, gemeten: false };
}

// Stap 4 — utilisatie per laadpunt (MWh/jaar), lineair van 6 MWh (2026)
// naar 12 MWh (2035). V5-methodiek: bezettingsgraad groeit mee met EV-adoptie.
// Vervangt de eerdere AC_KWH_PER_JAAR_TENDER met vast plafond op 1 MWh/maand.
// De oude tabel is bewaard als AC_KWH_PER_JAAR_TENDER_LEGACY voor eventuele
// referentie/vergelijking, maar wordt niet meer gebruikt in calcWijk.
const AC_KWH_PER_JAAR_TENDER_LEGACY = {
  2025:9000, 2026:9810, 2027:10693, 2028:11548, 2029:12472, 2030:13345,
  2031:14279, 2032:15279, 2033:16196, 2034:17006, 2035:17857,
};
export const AC_TRIGGER_MWH_MAAND = 1.0; // Bijlage 11, I.2 (legacy, niet meer gebruikt)

// V5: lineaire curve AC-utilisatie per socket per jaar (MWh)
// ── De afzetnorm per laadpunt ──────────────────────────────────────────
//
// Hoeveel kilowattuur er per jaar door één gewoon laadpunt gaat. Het model
// deelt de publieke laadvraag hierdoor, dus dit getal bepaalt rechtstreeks
// hoeveel laadpunten er nodig zijn.
//
// Tot 21 augustus 2026 stond hier een vaste lijn van 6 naar 12 MWh, voor elke
// gemeente hetzelfde en zonder bron. Die lijn is vervangen door een norm die
// de gemeente per jaar instelt, om drie redenen:
//
// 1. Er is geen gemeten afzet voor een gemeente waar de palen niet vol zitten.
//    Alleen Leuven (12.964 kWh) en Mechelen (11.164 kWh) hebben cijfers, en dat
//    zijn allebei metingen op de drukste palen van een centrumstad.
// 2. De hoogte van dit getal is geen natuurkundig gegeven maar een beleidskeuze:
//    hoe dicht wil een gemeente tegen de bijplaatsdrempel aan plannen.
// 3. Zolang het getal vastlag, was die keuze onzichtbaar. Het model hanteerde
//    impliciet 1,76 auto per laadpunt in 2027 oplopend naar 3,16 in 2035,
//    zonder dat iemand dat had gekozen.
//
// De MOW-drempel bijplaatsing ligt op 1.000 kWh per laadpunt per maand, dus
// 12.000 kWh per jaar. Plannen op 6.000 is plannen op de helft daarvan.
// De basisreeks: wat er geldt zolang een gemeente niets invult. Vastgesteld
// op 21 augustus 2026. De reeks loopt van 6.000 kWh in 2027 naar 10.000 in
// 2035, dus van de helft van de MOW-drempel naar 83 procent daarvan.
//
// Waarom oplopend: het aantal elektrische auto's groeit sneller dan het aantal
// laadpunten dat een gemeente kan plaatsen, dus gaat er per laadpunt meer
// stroom doorheen. Waarom niet tot de drempel: op 100 procent plan je precies
// op het moment dat de concessiehouder al moet bijplaatsen, en dan is er geen
// ruimte meer voor groei binnen het jaar.
// Gelijkmatig, 500 kWh per jaar. Op 24 augustus 2026 rechtgetrokken: daarvoor
// zat er een sprong van 1.000 naar 2030 en een vlakke stap tussen 2032 en 2033.
// Die twee onregelmatigheden gaven een dip in de investering van 2030 (82
// laadpunten erbij tegenover 194 het jaar ervoor) en een piek in 2033 (409).
// Een gemeente die haar investeringen wil spreiden, heeft daar niets aan.
export const AC_NORM_KWH_REEKS = {
  2027:  6000,  // 50 procent van de MOW-drempel
  2028:  6500,  // 54
  2029:  7000,  // 58
  2030:  7500,  // 63
  2031:  8000,  // 67
  2032:  8500,  // 71
  2033:  9000,  // 75
  2034:  9500,  // 79
  2035: 10000,  // 83
};
export const AC_NORM_KWH_BASIS = 6000;   // geldt voor 2026 en eerder

// De drempel waarboven de concessiehouder bijplaatst: 1.000 kWh per laadpunt
// per maand. Dient als referentie; de norm wordt getoond als percentage hiervan.
export const MOW_DREMPEL_BIJPLAATSING_KWH = 12000;

/**
 * De basisnorm voor een jaar, uit de reeks hierboven.
 */
export function acNormBasis(jaar) {
  return AC_NORM_KWH_REEKS[jaar] ?? (jaar < 2027 ? AC_NORM_KWH_BASIS : AC_NORM_KWH_REEKS[2035]);
}

export const NORM_JAREN = [2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035];

/**
 * De afzetnorm van een gemeente voor een bepaald jaar, in kWh per laadpunt.
 *
 * @param {number} jaar
 * @param {Object|null} normPerJaar - wat de gemeente heeft ingesteld, als
 *        {2027: 6000, 2028: 6500, ...}. Ontbreekt een jaar, dan geldt de
 *        basiswaarde.
 */
export function acNormKwh(jaar, normPerJaar = null) {
  const v = normPerJaar ? normPerJaar[jaar] : null;
  return Number.isFinite(v) && v > 0 ? v : acNormBasis(jaar);
}

/**
 * Dezelfde norm in MWh per jaar, want de rekenkern rekent in MWh.
 */
export function acUtilisatieMwhJaarV5(jaar, normPerJaar = null) {
  return acNormKwh(jaar, normPerJaar) / 1000;
}


// DC/HPC: eigen marktinschatting (P50, getoetst tegen Fastned-jaarcijfers 2025),
// gefaseerde groei 8% (2027-2028) / 6% (2029-2032) / 4% (2033-2035) per jaar.
const DC_HPC_START_MWH_MAAND = { dc: 4.0, hpc: 5.0 }; // 2026
function dcHpcGroeiPct(jaar) {
  if (jaar <= 2028) return 0.08;
  if (jaar <= 2032) return 0.06;
  return 0.04;
}

export const REDUNDANTIE_MARGE = 0.10; // dekt ook "Paal volgt Wagen", zie Leeswijzer §7

// ── V5-methodiek: extra parameters ─────────────────────────────────────
// Gedifferentieerde redundantie per laadtype (V5 audit FIX 5)
export const REDUNDANTIE_MARGE_AC  = 0.10; // AC: 10%
export const REDUNDANTIE_MARGE_DC  = 0.15; // DC: 15% (hogere criticaliteit)
export const REDUNDANTIE_MARGE_HPC = 0.20; // HPC: 20% (hoogste criticaliteit)

// Werk privé-fractie (aandeel bedrijfswagens met thuislader).
// Los van gemeentelijke privePct, omdat forensen ander laadgedrag hebben.
// V5 audit FIX 3.
export const WERK_PRIVE_PCT = 0.45;

// Fluvius onderregistratie correctiefactor. Uitgangspunt: 35% van de private
// laadpunten wordt niet aangemeld (conservatiever dan de 50% uit Solar Magazine).
// Werkelijk aantal privé-laadpunten ≈ Fluvius Fp × KAPPA, waarbij KAPPA = 1/0,65.
export const FLUVIUS_ONDERREGISTRATIE = 0.35;
export const FLUVIUS_KAPPA = 1 / (1 - FLUVIUS_ONDERREGISTRATIE); // ≈ 1,5385

// Gewichtsfactor semi-publiek in de totale beschikbare publiek+semi capaciteit.
// Bijlage 11 NAL: semi-publieke laadpunten voor 50% meetellen.
export const SEMI_GEWICHTSFACTOR = 0.5;

// Placeholder-daling privé-aandeel per jaar (V5 Stap 3). Wordt vervangen door
// cluster-uitkomst zodra Fluvius/MOW/DIV/Statbel-analyse beschikbaar is.
export const PRIVE_DALING_PER_JAAR = 0.02;

// ── Toets op de vloot in een gemeente ───────────────────────
// Het bestand van de FOD telt auto's op het adres waar ze zijn INGESCHREVEN,
// niet waar ze rijden. Een leasemaatschappij schrijft haar hele park in op het
// hoofdkantoor. Sinds 31 augustus 2026 komt het aantal auto's van een gemeente
// uit het huishoudbestand van Statbel, dus het aantal zelf is daar niet meer
// door vertekend. Het ELEKTRISCH AANDEEL wel: 82 procent van de volledig
// elektrische auto's in Belgie staat op naam van een bedrijf, dus in een
// gemeente met veel inschrijvingen zegt een lokaal EV-percentage vooral iets
// over leasewagens en niets over de auto's die er 's nachts staan.
//
// De maat daarvoor is de verhouding tussen die twee tellingen. Boven deze
// drempel is een lokaal EV-percentage niet bruikbaar. Voor Leuven is de
// verhouding 2,37 (85.188 ingeschreven tegenover 35.943 van gezinnen).
// De oude toets op auto's per inwoner (grenzen 0,65 en 1,00) is hiermee
// vervallen: die miste Leuven, want dat komt op 0,46 per inwoner.
// Zie actie 13 en 14 van actielijst_rekenmodel.docx.
export const VLOOT_DREMPEL = 1.2;

// Geeft null als een van beide tellingen ontbreekt of als de verhouding onder
// de drempel blijft, anders de verhouding met de twee getallen erbij.
// Blokkeert nooit; het is een melding, geen slot.
export function vlootSignaal(inschrijvingen, huishoudautos) {
  const a = Number(inschrijvingen), b = Number(huishoudautos);
  if (!Number.isFinite(a) || !Number.isFinite(b) || a <= 0 || b <= 0) return null;
  const verhouding = a / b;
  if (verhouding < VLOOT_DREMPEL) return null;
  return { verhouding, inschrijvingen: Math.round(a), huishoudautos: Math.round(b) };
}

export const YEARS = [2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035];

// ── Slim laden ──────────────────────────────────────────────────────────
// Slim laden betekent dat het vermogen per laadpaal op bepaalde momenten
// omlaag kan. Twee effecten, en ALLEBEI op het net, niet op de energievraag:
// 1) Netcongestievriendelijk laden: de piek daalt wanneer dat nodig is.
// 2) Bij structurele toepassing passen er meer laadpunten op dezelfde
//    aansluiting, omdat het vermogen over meer sockets wordt verdeeld.
//
// LET OP, twee lezingen van DEZELFDE ruimte, nooit bij elkaar op te tellen:
// je vraagt een lichtere aansluiting, OF je houdt de aansluiting en zet er
// een tweede paal bij. Niet allebei.
//
// De vroegere energiecorrectie van 3,5 procent op de AC-utilisatie is op
// 9 augustus 2026 verwijderd. Die verhoogde de behoefte met 3,6 procent op
// een mechanisme (langere bezetting per sessie) waar geen bron voor is.
// Zodra de gebruiksdata van het Departement MOW er is, kan dat effect
// alsnog en dan wel onderbouwd terugkomen.
//
// Alles in HELE PALEN. Een leverancier bouwt geen paal met 1,33 socket.
// Twee laadpunten per paal. Staat hier omdat de dekkingsnorm hem gebruikt.
const LAADPUNTEN_PER_PAAL = 2;
// De ondergrens die met slim laden gegarandeerd blijft. Het nominale
// vermogen van 11 kW en de aansluitwaarden staan BEWUST alleen in
// netcapaciteit.js in de backend; die worden door de aanroeper meegegeven.
export const SOCKET_KW_SLIM = 6;

// De aansluitwaarde zelf staat hier BEWUST niet. Die hoort in
// netcapaciteit.js in de backend en wordt door de aanroeper meegegeven,
// zodat er geen tweede plek ontstaat waar hij kan afwijken.

// Verdeelt een geheel getal over onderdelen naar hun gewicht, zo dat de som
// exact het oorspronkelijke getal blijft. Eerst iedereen naar beneden afronden,
// daarna de overgebleven eenheden uitdelen aan de grootste resten. Zonder deze
// stap staat er op de kaart 10 + 24 + 0 + 4 = 38 waar de wijk 37 nodig heeft.
// Staat hier omdat zowel het scherm als de plaatsingsmotor hem gebruikt.
export function verdeelHeel(totaal, gewichten) {
  const sleutels = Object.keys(gewichten);
  const som = sleutels.reduce((a, k) => a + (gewichten[k] || 0), 0);
  const uit = {};
  if (!som || !Number.isFinite(totaal)) {
    for (const k of sleutels) uit[k] = 0;
    return uit;
  }
  const doel = Math.round(totaal);
  const ruw = {};
  let gegeven = 0;
  for (const k of sleutels) {
    ruw[k] = doel * (gewichten[k] || 0) / som;
    uit[k] = Math.floor(ruw[k]);
    gegeven += uit[k];
  }
  const over = sleutels
    .sort((a, b) => (ruw[b] - uit[b]) - (ruw[a] - uit[a]))
    .slice(0, Math.max(0, doel - gegeven));
  for (const k of over) uit[k] += 1;
  return uit;
}

// De functies puntenPerAansluiting en slimLadenExtraRuimte stonden hier tot
// 9 september 2026. Ze rekenden de bestaande gewone laadpunten van een wijk
// maal twee, op de aanname dat elke bestaande paal aan 24,2 kVA hangt. Die
// aansluitwaarde per bestaande paal is niet bekend, dus het getal droeg niet.
// Slim laden wordt doorgerekend in netcapaciteit.js in de backend, waar de
// aansluitwaarde per soort paal wel in de berekening zit.

// ── Werkgerelateerde (forensen) laadvraag op bedrijventerrein ──────────
// Alleen relevant voor wijken met bedrijventerrein in hun wijktype; deze
// vraag komt van werknemers die er niet wonen, dus wordt NIET door de
// gewone bewoners/bezoekers/logistiek-doelgroepenmix gedekt (die is
// gebaseerd op wijk.voertuigen, oftewel wie er woont).
export const WERKNEMERS_PER_HA = 17.4; // Rebel-studie obv VLAIO/RSZ-data (West-Vlaanderen, 2015)
export const FORENZEN_KM_PER_DAG = 37; // SD Worx 2025 (retour), bevestigd door MOBILO/UAntwerpen en BELDAM
export const WERKDAGEN_PER_JAAR = 220;

// ── Dekkingsnorm (ruimtelijke ondergrens) ───────────────────────────────
// MOW: gemeenten zonder goedgekeurd strategisch laadplan zijn verplicht
// "Paal volgt Wagen" met een norm van maximaal 250 meter tussen aanvrager
// en laadpaal uit te voeren (VR-besluit, dec. 2025). De norm gaat over de
// afstand tussen PALEN, niet tussen individuele laadpunten (sockets); een
// paal heeft doorgaans 2 laadpunten. Dit is een baseline-referentie, GEEN
// vervanging van de energiegebaseerde berekening: een strategisch laadplan
// bestaat juist om actief, obv reële vraag, locaties en aantallen te
// bepalen, niet om deze theoretische spreidingsnorm blind te volgen. Zie
// calcWijk: dekkingAC beïnvloedt totAC/totLP/delta niet, het is een puur
// informatief vergelijkingscijfer.
export const DEKKING_AFSTAND_M = 250;
const DEKKING_STRAAL_KM = (DEKKING_AFSTAND_M / 2) / 1000;
const DEKKING_OPPERVLAK_PER_PAAL_KM2 = Math.PI * DEKKING_STRAAL_KM * DEKKING_STRAAL_KM;

/**
 * Minimaal aantal PALEN voor ruimtelijke dekking van een wijk (250m-norm),
 * los van de energiebehoefte.
 * @param {number} oppervlakteKm2
 */
export function dekkingPalen(oppervlakteKm2) {
  if (!oppervlakteKm2) return 0;
  return oppervlakteKm2 / DEKKING_OPPERVLAK_PER_PAAL_KM2;
}

/**
 * Dekkingsnorm uitgedrukt in laadpunten (2 per paal), zodat hij vergelijkbaar
 * is met de energiegebaseerde laadpunten-uitkomst. Puur ter referentie.
 * @param {number} oppervlakteKm2
 */
export function dekkingLaadpunten(oppervlakteKm2) {
  return dekkingPalen(oppervlakteKm2) * LAADPUNTEN_PER_PAAL;
}

// ── Stap 1: EV-aandeel ─────────────────────────────────────────────────
function interpoleerEvAandeelVlaanderen(jaar) {
  const a = EV_AANDEEL_VLAANDEREN;
  if (jaar <= 2025) return a[2025];
  if (jaar <= 2030) return a[2025] + (a[2030] - a[2025]) * (jaar - 2025) / 5;
  return a[2030] + (a[2035] - a[2030]) * (jaar - 2030) / 5;
}

/**
 * EV-aandeel voor een specifieke gemeente in een specifiek jaar.
 *
 * Tot 19 augustus 2026 werd de Vlaamse reeks hier vermenigvuldigd met de
 * welvaartsindex van de gemeente gedeeld door het Vlaams gemiddelde. Dat is
 * vervallen. Gemeten op de 289 Vlaamse gemeenten zonder leasevloot loopt het
 * EV-aandeel van wagens bij gezinnen van 1,67 procent in het vijfde met het
 * laagste autobezit naar 2,09 procent in het hoogste; over het hele bereik is
 * dat een factor 1,25, te weinig om een opslag per gemeente op te bouwen. Voor
 * Leuven leverde de oude regel 7,6 procent opslag op zonder onderbouwing.
 * Wijkt een gemeente aantoonbaar af, dan is daar het override-veld voor.
 *
 * @param {number} jaar
 * @param {number|null} override - eigen, lokaal cijfer; heeft voorrang indien opgegeven
 */
export function evAandeelGemeente(jaar, override = null) {
  if (override != null) return override;
  return interpoleerEvAandeelVlaanderen(jaar);
}

// ── Stap 4: utilisatie per laadpunt (V5: lineaire AC-curve 6→12 MWh/jaar) ─
// Behoud MwhMaand-signatuur voor backwards compatibility met bestaande callers.
export function acUtilisatieMwhMaand(jaar, normPerJaar = null) {
  return acUtilisatieMwhJaarV5(jaar, normPerJaar) / 12;
}
function groeiCurve(startWaarde, totJaar) {
  let waarde = startWaarde;
  for (let j = 2027; j <= totJaar; j++) waarde *= (1 + dcHpcGroeiPct(j));
  return waarde;
}
export function dcUtilisatieMwhMaand(jaar)  { return groeiCurve(DC_HPC_START_MWH_MAAND.dc,  jaar); }
export function hpcUtilisatieMwhMaand(jaar) { return groeiCurve(DC_HPC_START_MWH_MAAND.hpc, jaar); }

// ── V5-methodiek helpers ────────────────────────────────────────────────

/**
 * V5 Stap 2 + 3: bereken startjaarverhouding (privePct_0, publiekPct_0,
 * semiPct_0, semiFractie_0) EN de per-jaar gedaalde privePct_j met
 * bijbehorende publiekPct_j en semiPct_j (workplace charging = 50/50 pub/sem).
 *
 * @param {object} gemeente
 * @param {number} gemeente.fluvius   - geregistreerde Fluvius privé-laadpunten (Fp)
 * @param {number} gemeente.mow_qp_ac
 * @param {number} gemeente.mow_qp_dc
 * @param {number} gemeente.mow_qp_hpc
 * @param {number} gemeente.mow_qs_ac
 * @param {number} gemeente.mow_qs_dc
 * @param {number} gemeente.mow_qs_hpc
 * @param {number} jaar
 * @param {object} [opts]
 * @param {number} [opts.kappa=FLUVIUS_KAPPA]
 * @param {number} [opts.semiGewicht=SEMI_GEWICHTSFACTOR]
 * @param {number} [opts.priveDaling=PRIVE_DALING_PER_JAAR]
 * @param {number} [opts.startjaar=2026]
 */
export function berekenPubliekSemiSplitV5(gemeente, jaar, opts = {}) {
  const kappa       = opts.kappa       ?? FLUVIUS_KAPPA;
  const semiGewicht = opts.semiGewicht ?? SEMI_GEWICHTSFACTOR;
  const priveDaling = opts.priveDaling ?? PRIVE_DALING_PER_JAAR;
  const startjaar   = opts.startjaar   ?? 2026;

  const Fp = gemeente.fluvius ?? 0;
  const P  = Fp * kappa;

  const Qp = (gemeente.mow_qp_ac  ?? 0)
           + (gemeente.mow_qp_dc  ?? 0)
           + (gemeente.mow_qp_hpc ?? 0);
  const QsOng = (gemeente.mow_qs_ac  ?? 0)
              + (gemeente.mow_qs_dc  ?? 0)
              + (gemeente.mow_qs_hpc ?? 0);
  const Qs = semiGewicht * QsOng;
  const Q  = Qp + Qs;

  if (P + Q <= 0) {
    return {
      P: 0, Qp: 0, Qs: 0, Q: 0,
      privePct_0: 0.5, publiekPct_0: 0.25, semiPct_0: 0.25,
      semiFractie_0: 0.5,
      privePct_j: 0.5, publiekPct_j: 0.25, semiPct_j: 0.25,
    };
  }

  const privePct_0   = P / (P + Q);
  const publiekPct_0 = Qp / (P + Q);
  const semiPct_0    = Qs / (P + Q);
  const semiFractie_0 = Q > 0 ? Qs / Q : 0;

  // Per-jaar dalingsformule: privePct_j = privePct_0 - (j - startjaar) × daling
  // Geen ondergrens (bewuste keuze; verwijderd t.o.v. V5 excel).
  // Workplace charging: 50/50 verdeeld over publiek en semi (audit FIX 2).
  const jarenNaStart = Math.max(0, jaar - startjaar);
  const privePct_j = Math.max(0, privePct_0 - priveDaling * jarenNaStart);
  const werkelijkeDaling = privePct_0 - privePct_j;
  const publiekPct_j = publiekPct_0 + werkelijkeDaling / 2;
  const semiPct_j    = semiPct_0    + werkelijkeDaling / 2;

  return {
    P, Qp, Qs, Q,
    privePct_0, publiekPct_0, semiPct_0, semiFractie_0,
    privePct_j, publiekPct_j, semiPct_j,
  };
}

/**
 * V5 Stap 6+7: bereken sockets nodig en bijkomend, gesplitst per laadtype
 * (AC/DC/HPC) en per domein (publiek/semi). Werkt op stadsniveau: sommeert
 * de calcWijk-output over alle wijken van de gemeente.
 *
 * Bijkomend is gedefinieerd als CUMULATIEF tekort t.o.v. startjaar (voor
 * stadsweergave). Jaar-op-jaar delta per wijk wordt apart berekend via
 * berekenBijkomendPerWijkV5.
 *
 * @param {object} gemeente - moet 'wijken' bevatten, Fluvius, MOW-splitsing
 * @param {number} jaar
 * @param {object} params - identiek aan calcWijk-params
 */
export function berekenStadV5(gemeente, jaar, params) {
  const split = berekenPubliekSemiSplitV5(gemeente, jaar, params);

  const totPub = { AC: 0, DC: 0, HPC: 0 };
  const totSem = { AC: 0, DC: 0, HPC: 0 };
  const mwhPub = { AC: 0, DC: 0, HPC: 0 };
  const mwhSem = { AC: 0, DC: 0, HPC: 0 };

  const acPj  = acUtilisatieMwhJaarV5(jaar, gemeente?.normPerJaar ?? null);
  const dcPj  = dcUtilisatieMwhMaand(jaar)  * 12;
  const hpcPj = hpcUtilisatieMwhMaand(jaar) * 12;

  for (const w of (gemeente.wijken ?? [])) {
    const wc = calcWijk(w, {
      ...params,
      year: jaar,
      privePct: split.privePct_j,
      privePctOverride: null,
    });
    // Splitsen van mwhAC/DC/HPC naar publiek en semi via semiFractie_0
    const sf = split.semiFractie_0;
    mwhPub.AC  += wc.mwhAC  * (1 - sf);
    mwhPub.DC  += wc.mwhDC  * (1 - sf);
    mwhPub.HPC += wc.mwhHPC * (1 - sf);
    mwhSem.AC  += wc.mwhAC  * sf;
    mwhSem.DC  += wc.mwhDC  * sf;
    mwhSem.HPC += wc.mwhHPC * sf;
  }

  totPub.AC  = (mwhPub.AC  / acPj)  * (1 + REDUNDANTIE_MARGE_AC);
  totPub.DC  = (mwhPub.DC  / dcPj)  * (1 + REDUNDANTIE_MARGE_DC);
  totPub.HPC = (mwhPub.HPC / hpcPj) * (1 + REDUNDANTIE_MARGE_HPC);
  totSem.AC  = (mwhSem.AC  / acPj)  * (1 + REDUNDANTIE_MARGE_AC);
  totSem.DC  = (mwhSem.DC  / dcPj)  * (1 + REDUNDANTIE_MARGE_DC);
  totSem.HPC = (mwhSem.HPC / hpcPj) * (1 + REDUNDANTIE_MARGE_HPC);

  const bestaandPub = {
    AC:  gemeente.mow_qp_ac  ?? 0,
    DC:  gemeente.mow_qp_dc  ?? 0,
    HPC: gemeente.mow_qp_hpc ?? 0,
  };
  const bestaandSem = {
    AC:  gemeente.mow_qs_ac  ?? 0,
    DC:  gemeente.mow_qs_dc  ?? 0,
    HPC: gemeente.mow_qs_hpc ?? 0,
  };

  // Cumulatief bijkomend op stadsniveau (max 0 als bestaand > nodig)
  const bijPub = {
    AC:  Math.max(0, totPub.AC  - bestaandPub.AC),
    DC:  Math.max(0, totPub.DC  - bestaandPub.DC),
    HPC: Math.max(0, totPub.HPC - bestaandPub.HPC),
  };
  const bijSem = {
    AC:  Math.max(0, totSem.AC  - bestaandSem.AC),
    DC:  Math.max(0, totSem.DC  - bestaandSem.DC),
    HPC: Math.max(0, totSem.HPC - bestaandSem.HPC),
  };

  return {
    split,
    nodig: { pub: totPub, sem: totSem },
    bijkomend_cumulatief: { pub: bijPub, sem: bijSem },
    mwh: { pub: mwhPub, sem: mwhSem },
    bestaand: { pub: bestaandPub, sem: bestaandSem },
  };
}

/**
 * V5 Stap 7: bijkomend PER WIJK als jaar-op-jaar delta.
 * bijkomend_j_wijk = max(0, nodig_j_wijk - max(nodig_(j-1)_wijk, bestaand_wijk))
 *
 * NB: bestaand wordt hier per wijk als 0 aangenomen; caller moet zelf
 * bestaandPerWijk aftrekken indien beschikbaar (bijv. via nearest-centroid
 * MOW-toewijzing in de app).
 *
 * @param {object} gemeente
 * @param {object} params
 * @param {number[]} jaren - array van jaartallen, bijv. [2026,2027,...,2035]
 * @param {object} [bestaandPerWijk] - optioneel per wijk-id een {AC,DC,HPC} bestaandobject
 */
export function berekenBijkomendPerWijkV5(gemeente, params, jaren, bestaandPerWijk = {}) {
  const nodigCumulatief = {}; // wijkId -> jaar -> {AC,DC,HPC}
  for (const w of (gemeente.wijken ?? [])) {
    nodigCumulatief[w.id] = {};
    for (const jaar of jaren) {
      const split = berekenPubliekSemiSplitV5(gemeente, jaar, params);
      const wc = calcWijk(w, {
        ...params,
        year: jaar,
        privePct: split.privePct_j,
        privePctOverride: null,
      });
      nodigCumulatief[w.id][jaar] = {
        AC:  wc.totAC,
        DC:  wc.totDC,
        HPC: wc.totHPC,
      };
    }
  }

  const result = {}; // wijkId -> jaar -> {AC,DC,HPC}
  for (const w of (gemeente.wijken ?? [])) {
    result[w.id] = {};
    const bw = bestaandPerWijk[w.id] ?? { AC: 0, DC: 0, HPC: 0 };
    for (let i = 0; i < jaren.length; i++) {
      const jaar = jaren[i];
      const nodig = nodigCumulatief[w.id][jaar];
      const bij = { AC: 0, DC: 0, HPC: 0 };
      for (const tp of ['AC', 'DC', 'HPC']) {
        if (i === 0) {
          bij[tp] = Math.max(0, nodig[tp] - bw[tp]);
        } else {
          const vorig = nodigCumulatief[w.id][jaren[i-1]];
          const referentie = Math.max(vorig[tp], bw[tp]);
          bij[tp] = Math.max(0, nodig[tp] - referentie);
        }
      }
      result[w.id][jaar] = bij;
    }
  }
  return { bijkomend_delta_per_wijk: result, nodig_cumulatief_per_wijk: nodigCumulatief };
}

// ── Provincies in Cijfers API-key placeholder (V5) ─────────────────────
// De API-key wordt straks als Railway env var PROVINCIES_INCIJFERS_API_KEY
// geïnjecteerd in de backend. Frontend haalt EV-aandeel op via het backend
// endpoint /geo/ev-aandeel/:nisCode dat de key server-side gebruikt.
// Deze constante is puur documentatief en wordt zelf niet gebruikt in
// calcWijk; het endpoint-antwoord vult wijk.evAandeelOverride[jaar].
export const EV_AANDEEL_API_ENDPOINT = '/geo/ev-aandeel'; // + :nisCode

/**
 * Berekent voor één wijk, in één jaar, de bruto AC/DC/HPC-behoefte
 * (inclusief redundantiemarge, exclusief aftrek van bestaande infrastructuur,
 * dat gebeurt op app-niveau).
 *
 * @param {object} wijk - { voertuigen, wijktype: string[] }
 * @param {object} params
 * @param {number} params.year
 * @param {number|null} [params.evAandeelOverride] - eigen, lokaal EV-aandeel i.p.v. de Vlaamse reeks
 * @param {Object|null} [params.normPerJaar] - de afzetnorm per jaar die de gemeente heeft
 *        ingesteld, als {2027: 6000, ...}. Leeg laten valt terug op de basiswaarde van
 *        6.000 kWh per laadpunt per jaar.
 * @param {number} params.privePct - berekend privé-percentage (Stadsmonitor / Leuven-dataset / Fluvius), 0 tot 1
 * @param {number|null} [params.privePctOverride] - "% publiek laden"-invoer als override op het berekende privé-percentage
 * @param {number} [params.redundantieMarge]
 * @param {number} [params.trendFactor]
 * @param {Object|null} [params.autoGroei] - de groei van het aantal auto's per jaar, als
 *        {2027: 1.009, ...}, ten opzichte van het jaar waarin de auto's geteld zijn. Komt
 *        uit de huishoudens van de gemeente (server, /gemeenten/:id/huishoudgroei). Leeg of
 *        een ontbrekend jaar betekent geen groei.
 */
export function calcWijk(wijk, params) {
  const {
    year,
    evAandeelOverride = null,
    normPerJaar = null,
    privePct,
    privePctOverride = null,
    redundantieMarge = REDUNDANTIE_MARGE,
    trendFactor = 1,
    autoGroei = null,
  } = params;

  // Stap 1: energiebehoefte. Het aantal auto's groeit mee met het aantal
  // huishoudens; het aantal auto's per huishouden blijft dat van de telling.
  // Besluit van HL, 21 oktober 2026.
  const groei = autoGroei && Number.isFinite(Number(autoGroei[year])) ? Number(autoGroei[year]) : 1;
  const evPct = evAandeelGemeente(year, evAandeelOverride);
  const evs = wijk.voertuigen * groei * evPct;
  const totMwh = evs * JAARKM * VERBRUIK_PER_KM * STADSFACTOR / 1000 * trendFactor;

  // Stap 2: privé vs. publiek+semipubliek
  const gebruiktPrivePct = privePctOverride != null ? privePctOverride : (privePct ?? 0.5);
  const mwhPubliek = totMwh * (1 - gebruiktPrivePct);

  // Stap 3: doelgroepenmix (wijktype, met combi-berekening bij hybride wijken) + AC/DC/HPC
  const types = (wijk.wijktype && wijk.wijktype.length) ? wijk.wijktype : ['woonwijk'];
  const mix = { bew: 0, bez: 0, log: 0 };
  types.forEach(t => {
    const m = WIJKTYPE_MIX[t] || WIJKTYPE_MIX.woonwijk;
    mix.bew += m.bew / types.length;
    mix.bez += m.bez / types.length;
    mix.log += m.log / types.length;
  });
  // Tot 9 september 2026 kon per wijk een deel van de publieke laadvraag aan
  // het openbaar vervoer worden toegewezen, met een eigen laadtypemix. Dat
  // veld is vervallen: een gemeente kan een aandeel van een laadvraag niet
  // inschatten. Komt het terug, dan in het aantal bussen dat hier laadt, met
  // een onderbouwd jaarverbruik per bus.
  const mwhBew = mwhPubliek * mix.bew;
  const mwhBez = mwhPubliek * mix.bez;
  const mwhLog = mwhPubliek * mix.log;

  // Werkgerelateerde (forensen) vraag, alleen voor bedrijventerrein-wijken.
  // Optie 2 (bewust gekozen i.p.v. optie 1): alleen het deel dat NIET privé/
  // semi-publiek door de werkgever wordt opgelost telt mee als publieke
  // vraag, met dezelfde privé%-verhouding als de rest van het model. Qua
  // laadtype behandeld als "bewoners" (lang, rustig parkeren tijdens een
  // volledige werkdag lijkt qua patroon meer op overnachten dan op kort
  // winkelbezoek), dus overwegend AC.
  const werkgerelateerdRelevant = types.includes('bedrijventerrein');
  let mwhWerk = 0;
  if (werkgerelateerdRelevant && wijk.oppervlakteKm2) {
    const werknemers = wijk.oppervlakteKm2 * 100 * WERKNEMERS_PER_HA;
    const werknemersEvs = werknemers * evPct;
    const kwhPerWerknemerJaar = FORENZEN_KM_PER_DAG * WERKDAGEN_PER_JAAR * VERBRUIK_PER_KM;
    const mwhWerkBruto = werknemersEvs * kwhPerWerknemerJaar / 1000;
    mwhWerk = mwhWerkBruto * (1 - gebruiktPrivePct); // optie 2: alleen niet-privé-opgeloste deel
  }

  const mwhAC  = mwhBew * DOELGROEP_LAADTYPE.bew.ac  + mwhBez * DOELGROEP_LAADTYPE.bez.ac  + mwhLog * DOELGROEP_LAADTYPE.log.ac   + mwhWerk * DOELGROEP_LAADTYPE.bew.ac;
  const mwhDC  = mwhBew * DOELGROEP_LAADTYPE.bew.dc  + mwhBez * DOELGROEP_LAADTYPE.bez.dc  + mwhLog * DOELGROEP_LAADTYPE.log.dc   + mwhWerk * DOELGROEP_LAADTYPE.bew.dc;
  const mwhHPC = mwhBew * DOELGROEP_LAADTYPE.bew.hpc + mwhBez * DOELGROEP_LAADTYPE.bez.hpc + mwhLog * DOELGROEP_LAADTYPE.log.hpc + mwhWerk * DOELGROEP_LAADTYPE.bew.hpc;

  // Stap 4: utilisatie per laadpunt -> bruto aantal, met redundantiemarge
  // Slim laden speelt hier BEWUST geen rol meer. De eerdere correctie van
  // 3,5 procent op de AC-utilisatie is op 9 augustus 2026 verwijderd: die
  // verhoogde de behoefte op een mechanisme (langere bezetting per sessie)
  // waar geen bron voor is. Slim laden werkt alleen op het aansluitvermogen,
  // zie het blok Slim laden hierboven en netcapaciteit.js.
  const acPerJaar  = acUtilisatieMwhJaarV5(year, normPerJaar);
  const dcPerJaar  = dcUtilisatieMwhMaand(year)  * 12;
  const hpcPerJaar = hpcUtilisatieMwhMaand(year) * 12;

  const totAC  = (mwhAC  / acPerJaar)  * (1 + redundantieMarge);
  const totDC  = (mwhDC  / dcPerJaar)  * (1 + redundantieMarge);
  const totHPC = (mwhHPC / hpcPerJaar) * (1 + redundantieMarge);

  // Ruimtelijke dekkingsnorm (MOW 250m-norm, "Paal volgt Wagen"), alleen
  // relevant voor AC en alleen zinvol bij woonwijk/binnenstad (geen
  // bewoners-"dicht bij huis"-behoefte op een zuiver bedrijventerrein).
  // LET OP: dit is bewust een REFERENTIECIJFER, geen ondergrens die de
  // uitkomst overschrijft. Een strategisch laadplan bestaat juist om obv
  // reële energievraag actief te bepalen waar en hoeveel palen nodig zijn;
  // de 250m-regel is de blinde, theoretische baseline die geldt bij het
  // ONTBREKEN van zo'n plan, niet iets waar de uitkomst van dit model
  // zelf aan ondergeschikt zou moeten zijn. totAC blijft daarom altijd
  // energiegebaseerd; dekkingAC wordt niet in totLP/delta/bijkomend
  // meegenomen, alleen getoond ter vergelijking.
  const dekkingRelevant = types.some(t => t === 'woonwijk' || t === 'binnenstad');
  const dekkingAC = dekkingRelevant ? dekkingLaadpunten(wijk.oppervlakteKm2) : 0;
  const dekkingLigtHoger = dekkingAC > totAC;

  return {
    evs, evPct, privePct: gebruiktPrivePct,
    totMwh: totMwh + mwhWerk, mwhPubliek: mwhPubliek + mwhWerk, mwhWerk, mwhAC, mwhDC, mwhHPC,
    // De laadvraag per doelgroep, zodat het scherm niet dezelfde formule hoeft
    // na te bouwen. mwhWerk staat er los naast en wordt qua laadgedrag als
    // bewoners behandeld, zie de toelichting hierboven.
    mwhBew, mwhBez, mwhLog,
    totAC, totACEnergie: totAC, dekkingAC, dekkingLigtHoger,
    totDC, totHPC,
    totLP: totAC + totDC + totHPC,
  };
}
